// extracted by mini-css-extract-plugin
export default {"backContainer":"BackButton_backContainer__3-dno","backTitle":"BackButton_backTitle__IcCKU"};